import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import {
  EmploymentInformation,
  InsuranceDetails,
  PersonalInformation,
  VisaPassportInformation,
} from './types';

type DataRow = {
  title: string;
  description: string;
  isCopy?: boolean;
};

export const prepareEmploymentInformation = (
  employmentInformation: EmploymentInformation
): DataRow[] => {
  return [
    {
      title: 'Labor Card Number',
      description:
        employmentInformation.laborCardNumber || EMPTY_FIELD_PLACEHOLDER,
      isCopy: Boolean(employmentInformation.laborCardNumber),
    },
    {
      title: 'Labor Card Expiry',
      description:
        employmentInformation.laborCardExp || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'MOL Person No.',
      description: employmentInformation.molPersonNo || EMPTY_FIELD_PLACEHOLDER,
      isCopy: Boolean(employmentInformation.molPersonNo),
    },
    {
      title: 'Sponsor Company',
      description: employmentInformation.sponsorComp || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Arabic Designation',
      description:
        employmentInformation.arabicDesignation || EMPTY_FIELD_PLACEHOLDER,
    },
  ];
};

export const prepareInsuranceDetails = (
  insuranceDetails: InsuranceDetails
): DataRow[] => {
  return [
    {
      title: 'Beneficiary Name',
      description: insuranceDetails.beneficiaryName || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Insurance Provider',
      description:
        insuranceDetails.insuranceProvider || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Insurance Card Number',
      description:
        insuranceDetails.insuranceCardNumber || EMPTY_FIELD_PLACEHOLDER,
      isCopy: Boolean(insuranceDetails.insuranceCardNumber),
    },
    {
      title: 'Eligibility',
      description: insuranceDetails.eligibility || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Category',
      description: insuranceDetails.category || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Expiry Date',
      description: insuranceDetails.expDate || EMPTY_FIELD_PLACEHOLDER,
    },
  ];
};

export const preparePersonalInformation = (
  personalInformation: PersonalInformation
): DataRow[] => {
  return [
    {
      title: 'National/Emirates ID',
      description: personalInformation.nationalId || EMPTY_FIELD_PLACEHOLDER,
      isCopy: Boolean(personalInformation.nationalId),
    },
    {
      title: 'National ID Expiry',
      description: personalInformation.nationIdExp || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Arabic Name',
      description: personalInformation.arabicName || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Arabic Nationality',
      description:
        personalInformation.arabicNationality || EMPTY_FIELD_PLACEHOLDER,
    },
  ];
};

export const prepareVisaPassportInformation = (
  visaPassportInformation: VisaPassportInformation
): DataRow[] => {
  return [
    {
      title: 'Passport No.',
      description:
        visaPassportInformation.passportNo || EMPTY_FIELD_PLACEHOLDER,
      isCopy: Boolean(visaPassportInformation.passportNo),
    },
    {
      title: 'Passport Expiry',
      description:
        visaPassportInformation.passportExp || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Visa No.',
      description: visaPassportInformation.visaNo || EMPTY_FIELD_PLACEHOLDER,
      isCopy: Boolean(visaPassportInformation.visaNo),
    },
    {
      title: 'Visa Expiry',
      description: visaPassportInformation.visaExp || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'Visa File No.',
      description:
        visaPassportInformation.visaFileNo || EMPTY_FIELD_PLACEHOLDER,
    },
    {
      title: 'VFN Issue Date',
      description:
        visaPassportInformation.vfnIssueDate || EMPTY_FIELD_PLACEHOLDER,
    },
  ];
};
